import React, { Component } from 'react';
import classNames from 'classnames/bind';
import styles from './ReviewBox.scss';

const cx = classNames.bind(styles);

class ReviewBox extends Component {
  render() {
    const { total, star, type = '', scoreavg, style } = this.props;
    return type === 'web' ? (
      <div className={cx('ReviewBox')} style={style}>
        <ReviewStartPoint star={star} type={type} />
        <p className="staravg">
          {scoreavg}
          <span className="total">({total})</span>
        </p>
      </div>
    ) : type === 'mobile' ? (
      <div className={cx('ReviewBoxMobile')}>
        <ReviewStartPoint star={star} type={type} />
        <p className="staravg">
          {scoreavg}
          <span className="total">({total})</span>
        </p>
      </div>
    ) : type === 'small' ? (
      <div className={cx('ReviewBoxSmall')}>
        <ReviewStartPoint star={star} type={type} />
        <p className="staravg">{star}</p>
      </div>
    ) : type === 'micro' ? (
      <div className={cx('ReviewBoxSmall', 'micro')}>
        <ReviewStartPoint star={star} type={type} />
        {/* <p className="staravg">{star}</p> */}
      </div>
    ) : (
      ''
    );
  }
}

export default ReviewBox;

const ReviewStartPoint = ({ star = 0, type, max = 5 }) => {
  // console.log({ star });
  const arr = [false, false, false, false, false].map((a, i) =>
    i < star ? true : false,
  );
  const stars = arr.map((a, i) => {
    // console.log({ a });
    return (
      <div
        style={{ display: 'inline-block' }}
        key={`starpoint-${i}`}
        className={`star-point ${a ? 'on' : ''}`}
      ></div>
    );
  });

  // console.log({ stars });

  return <div className="">{stars}</div>;
};
